export default "__VITE_ASSET__DlprrSC___"